'use client';

import BlinkingIndicator from '@/components/ui/BlinkingIndicator/BlinkingIndicator';
import ImageFigure from '@/components/ui/ImageFigure/ImageFigure';
import RotatingTicker from '@/components/ui/RotatingTicker/RotatingTicker';
import { useDictionary } from '@/context/DictionaryContext';
import { Liveblog } from '@/types/content';
import { formatRelativeTime, hasTimeExceeded } from '@/utils/timeUtils';
import { useMemo } from 'react';

import styles from './LiveblogIntro.module.scss';

interface LiveblogIntroProps {
  liveblog: Liveblog;
}

const LiveblogIntro = ({ liveblog }: LiveblogIntroProps) => {

  const { t } = useDictionary();
  const isLiveblogActive = hasTimeExceeded(liveblog.updatedAt, '5 hours') === false;

  const summaryPoints = useMemo(
    () =>
      liveblog.points?.map((point, index) => (
        <div key={index}>
          <p>{point}</p>
        </div>
      )) || null,
    [liveblog.points]
  );

  return (
    <section>
      <header className={styles.liveblogIntro}>
        <div className={styles.liveblogIntro__header}>
          {isLiveblogActive && <section className={styles.liveblogBagde}>
            <div className={styles.liveblogBagde__live}>
              <BlinkingIndicator />
              <strong>{t('label.live')}</strong>
            </div>
            <div className={styles.liveblogBagde__lastUpdated}>
              <RotatingTicker
                items={[
                  '',
                  t('updatedAt', { date: formatRelativeTime(new Date(liveblog.updatedAt), liveblog.language) }),
                ]}
                interval={4000}
              />
            </div>
          </section>}
          <h1 className={styles.headline}>{liveblog.title}</h1>
        </div>
        {liveblog.image &&
          <ImageFigure
            image={liveblog.image}
            alt={liveblog.title}
            className={styles.liveblogIntro__image}
          />
        }
        {summaryPoints && (
          <div className={styles.liveblogIntro__summary}>
            <div className={styles.liveblogIntro__summaryWrapper}>
              <div className={styles.liveblogIntro__summaryPoints}>
                <strong>{t('label.summary')}</strong>
                <RotatingTicker
                  items={summaryPoints as any}
                  interval={8000}
                  showControls
                />
              </div>
            </div>
          </div>
        )}
      </header>
    </section>
  );
};

export default LiveblogIntro;